import {atom} from "recoil";
import {persistAtomEffect} from "../effects/persistAtom";

export const sidebarHiddenMenusState = atom({
  key: 'SidebarHiddenMenusState',
  default: [],
  effects: [
    ({onSet}) => {
      onSet(newValue => {
        //remove duplicated values
        const uniqueValues = Array.from(new Set(newValue));
        //remove empty values
        return uniqueValues.filter(value => value !== "");
      });
    },
    persistAtomEffect,
  ]
});